import { ApiResponse, getRaw, postRaw } from 'services/api';

export const USER_CONTEXT_URL = '/i/user/context';
export const CHANGE_PROJECT_URL = '/settings/changeProject';
export const ACCEPT_GDPR_URL = '/audit/acceptGdpr';

/**
 * Get endpoint for fetching user context
 */
export const getUserContext = (): Promise<ApiResponse> => getRaw(USER_CONTEXT_URL);

/**
 * Get endpoint for requesting data from a new project during a project change
 * @param projectId
 */
export const changeUserProjectRequest = (projectId: string): Promise<ApiResponse> =>
  getRaw(`${CHANGE_PROJECT_URL}?projectId=${projectId}`);

/**
 * Post endpoint for acceptGdpr
 */
export const acceptGdpr = (): Promise<ApiResponse> => postRaw(ACCEPT_GDPR_URL);
